"use client"
/* */
import { jsxs, jsx } from 'react/jsx-runtime';
import { ColumnLayout } from '../ColumnLayout/ColumnLayout.mjs';
import { FieldError } from '../FieldError/FieldError.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';
import '../../lib/propsContext/propsContext.mjs';
import 'react';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { TunnelProvider, TunnelExit } from '@mittwald/react-tunnel';
import clsx from 'clsx';
import * as Aria from 'react-aria-components';
import formFieldStyles from '../FormField/FormField.module.scss.mjs';
import styles from './CheckboxGroup.module.scss.mjs';

const CheckboxGroup = flowComponent("CheckboxGroup", (props) => {
  const { children, className, s, m, l, ref, ...rest } = props;
  const rootClassName = clsx(formFieldStyles.formField, className);
  const propsContext = {
    Label: {
      className: formFieldStyles.label
    },
    FieldDescription: {
      className: formFieldStyles.fieldDescription,
      tunnelId: "fieldDescription"
    },
    FieldError: {
      className: formFieldStyles.customFieldError,
      tunnelId: "fieldError"
    },
    Checkbox: {
      tunnelId: "checkboxes"
    },
    CheckboxButton: {
      tunnelId: "checkboxButtons"
    }
  };
  return /* @__PURE__ */ jsxs(Aria.CheckboxGroup, { ...rest, className: rootClassName, ref, children: [
    /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsxs(TunnelProvider, { children: [
      children,
      /* @__PURE__ */ jsx(ColumnLayout, { s, m, l, className: styles.checkboxGroup, children: /* @__PURE__ */ jsx(TunnelExit, { id: "checkboxButtons" }) }),
      /* @__PURE__ */ jsx(
        ColumnLayout,
        {
          s: s ?? [1],
          m: m ?? [1],
          l: l ?? [1],
          rowGap: "s",
          className: styles.checkboxGroup,
          children: /* @__PURE__ */ jsx(TunnelExit, { id: "checkboxes" })
        }
      ),
      /* @__PURE__ */ jsx(TunnelExit, { id: "fieldDescription" }),
      /* @__PURE__ */ jsx(TunnelExit, { id: "fieldError" })
    ] }) }),
    /* @__PURE__ */ jsx(FieldError, { className: formFieldStyles.fieldError })
  ] });
});

export { CheckboxGroup, CheckboxGroup as default };
//# sourceMappingURL=CheckboxGroup.mjs.map
